<template lang="pug">
Shell
  template(#header)
    EcreativOrganismsPresentingLogoAndCallToNavigateMainDirectory2(
      :mainNavLinks="mainNavLinks"
      :mainNavLinksMobile="mainNavLinksMobile"
      :secondNavLinks="shellData?.secondNavFooterNavigation?.children ?? []"
    )
  template(#default)
    .siteContent
      .container
        .row.text-center.d-flex.flex-column.justify-content-center.py-5.my-5
          .col
            div(v-if='is404' aria-live="polite")
              h1.mb-5 Page not found!
              h4.mb-3 Sorry, but the page you were looking for could not be found.
            div(v-else)
              h1.mb-5 Error - {{ error?.statusCode || 'Unknown' }}
              h4.mb-3 {{ error?.message || 'An unexpected error occurred.' }}
            p You can&nbsp;
              NuxtLink(to="/") return to our front page
              | &nbsp;or&nbsp;
              NuxtLink(to="/contact-us") contact us
              | &nbsp;if you can't find what you're looking for.
  template(#footer)
    EcreativOrganismsFooterNavigationAndLegal(
      :navigation="shellData?.footerNavigation"
      :legalNavigation="shellData?.footerLegalNavigation"
    )
</template>

<script setup lang="ts">
/* eslint-disable */
import { computed } from 'vue';
import { useHead, useFetch } from '#imports';
import type { ShellData, NavigationNode } from 'data-types-config';

const props = defineProps<{
  error: { statusCode?: number; statusMessage?: string; message?: string };
}>();

const is404 = computed(() => (props.error?.statusCode || 500) === 404);

useHead({
  title: is404.value ? '404 — Page not found' : 'Error',
  meta: [{ name: 'robots', content: 'noindex' }],
});

const { data: shellData } = useFetch<ShellData>('/api/shell/navigation', {
  key: 'error-shell-navigation',
  default: () => ({}) as ShellData,
  server: true,
  lazy: false,
});

const mainNavLinks = computed<NavigationNode[]>(() => [
  ...(shellData.value?.headerBeliefsNavigation?.children ?? []),
  ...(shellData.value?.headerQandaNavigation?.children ?? []),
  ...(shellData.value?.headerCampaignsNavigation?.children ?? []),
]);

const mainNavLinksMobile = computed<NavigationNode[]>(() => [
  ...(shellData.value?.mobileDiscoverNavigation?.children ?? []),
  ...(shellData.value?.mobileQandaNavigation?.children ?? []),
  ...(shellData.value?.mobileMoreNavigation?.children ?? []),
]);
</script>

<style lang="scss" scoped>
.app .siteContent {
  padding: 20px 0 !important;
}
</style>
